import GetIssuuDocumentCoverRequestModelBase from '../_generated/modelBases/get-issuu-document-cover-request-model-base';

export default class GetIssuuDocumentCoverRequestModel extends GetIssuuDocumentCoverRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
